<template>
  <transition name="fade">
    <div
      class="max-w-sm w-full bg-white shadow-lg rounded-ds pointer-events-auto ring-1 ring-black ring-opacity-5 overflow-hidden"
    >
      <div class="p-4">
        <div class="flex items-start">
          <div class="flex-shrink-0">
            <div class="flex-shrink-0" v-if="isSuccess">
              <svg
                class="h-6 w-6 text-green-400"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </div>
            <div class="flex-shrink-0" style="margin-top: 2px;" v-if="isError">
              <svg
                class="w-6 h-6 text-red-400"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                  clip-rule="evenodd"
                ></path>
              </svg>
            </div>
          </div>
          <div class="flex-shrink-0" v-if="isWarning">
              <svg
                class="h-6 w-6 text-orange-400"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </div>
          <div class="ml-3 w-0 flex-1 pt-0.5">
            <p class="text-sm font-medium text-gray-900" v-if="toast.title">
              {{ toast.title }}
            </p>
            <p class="mt-1 text-sm text-gray-600" v-html="toast.content"></p>
          </div>
          <div class="ml-4 flex-shrink-0 flex">
            <button
              @click="close"
              class="bg-white rounded-md inline-flex text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              <span class="sr-only">Close</span>
              <!-- Heroicon name: solid/x -->
              <svg
                class="h-5 w-5"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
                aria-hidden="true"
              >
                <path
                  fill-rule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clip-rule="evenodd"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
    props: {
        toast: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            timeout: null
        };
    },
    mounted() {
        setTimeout(() => {
            this.$store.dispatch("notification/removeToast", this.toast);
        }, 10000);
    },
    methods: {
        close() {
            this.$store.dispatch("notification/removeToast", this.toast);
        }
    },
    computed: {
        toastTypeClass() {
            return `alert-${this.toast.type}`;
        },
        isSuccess() {
            return this.toast.type === "success";
        },
        isWarning() {
            return this.toast.type === "warning";
        },
        isError() {
            return this.toast.type === "error";
        },
        containerClass() {
            switch (this.toast.type) {
                case "success":
                    return "bg-green-200";
                case "error":
                    return "bg-white";
                case "warning":
                    return "bg-orange-200";
                default:
                    return "bg-white";
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.fade-leave-active {
  transition: opacity 1s;
}
.fade-leave-to {
  opacity: 0;
}
</style>
